import React, { Component } from 'react';
import { red } from '@mui/material/colors';
import { Box, Button, Container, FormControl, FormHelperText, InputLabel, Link, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useNavigate, Navigate } from "react-router-dom";

import AddAttachment from '../components/AddAttachment';
import { checkStatus, goToLogin } from '../checkStatus';
import { getBaseUrl } from '../env';


const defaultState = {
  employer: null,
  candidates: null,
  candidateId: '',
  loading: true,
  file: null,
  terms: '',
  notes: '',
  execution: '',
  expiration: '',
  attachmentCategory: 'None',
  attachment: null,
  name: null,
  filename: null,
  size: null,
  invoice: null,
  showInvoice: false,
  contentType: null,
  attachments: [],
  successMessage: null,
  errorMessage: null,
  salaryError: null,
  feeError: null,
  candidateError: null,
};

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

const BackButton = (props) => {
  const navigate = useNavigate();
  return (
    <Link href={props.url} onClick={(evt) => {evt.preventDefault();navigate(props.url)}} underline="hover">Back to {props.name}</Link>
  )
}

class AddEmplAttachmentPage extends Component {

  constructor(props) {
    super(props);
    this.state = defaultState;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleCandidateChange = this.handleCandidateChange.bind(this);
    this.onFilesAdded = this.onFilesAdded.bind(this);
  }

  async componentDidMount() {
    const employerId = this.props.params.id;
    const employerUrl = `${getBaseUrl()}/v1/employer/${employerId}`;
    fetch(employerUrl, {credentials:'include'})
      .then(result => checkStatus(result))
      .then(({ data }) => {
        if (data?.length) {
          const [employer] = data;
          return this.setState({ employer });
        }
      })
      .catch(error => {
        console.error(error);
        if (error.code === 401) {
          return goToLogin();
        }
        this.setState({ errorMessage: error.message, error });
      })
      .finally(() => {
        this.setState({ loading: false });
      });

    const candidatesUrl = `${getBaseUrl()}/v1/employer/${employerId}/candidate`;
    fetch(candidatesUrl, {credentials:'include'})
      .then(result => checkStatus(result))
      .then(items => {
        return this.setState({ candidates: items.data });
      })
      .catch(error => {
        console.error(error);
        this.setState({ errorMessage: error.message || 'Unable to load candidates', error });
      })
      .finally(() => {
        this.setState({ loading: false });
      });

    const nextInvoiceUrl = `${getBaseUrl()}/v1/next-invoice`;
    fetch(nextInvoiceUrl, {credentials:'include'})
      .then(result => checkStatus(result))
      .then(({ nextInvoice }) => {
        console.log('nextInvoice: ', nextInvoice);
        this.setState({ invoice: nextInvoice });
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    if (name)
      this.setState({ [name]: value });
  }

  handleCategoryChange(event) {
    const { name, value } = event.target;
    //:129console.log(`handleCategoryChange: ${name} = ${value}`);
    if (name) {
      this.setState({ [name]: value });
      this.setState({ showInvoice: value === 'Invoice' });
    }
  }

  handleCandidateChange(event) {
    const { name, value } = event.target;
    console.log(`handleCandidateChange: ${name} = ${value}`);
    this.setState({ candidateId: value });
  }

  onFilesAdded(files, contents) {
    this.setState({ files });

    const file = files[0];
    this.setState({ file });
    this.setState({ filename: file.name });
    this.setState({ size: file.size });
    this.setState({ contentType: file.type });
    this.setState({ attachment: contents[0] });
  }

  onDeleteAttachment(event, file, index) {
    event.preventDefault();
    const attachments = [...this.state.attachments];
    attachments.splice(index, 1);
    this.setState({ attachments });
  }

  validate() {
    if (this.state.showInvoice) {
      if (!this.state.invoice) {
        this.setState({ invoiceError: 'Invoice number is required' });
        return false;
      } else
        this.setState({ invoiceError: null });

      if (!this.state.salary) {
        this.setState({ salaryError: 'Salary is required' });
        return false;
      } else
        this.setState({ salaryError: null });

      if (!this.state.fee) {
        this.setState({ feeError: 'Fee is required' });
        return false;
      } else
        this.setState({ feeError: null });

      if (!this.state.candidateId) {
        this.setState({ candidateError: 'Invoice Candidate is required' });
        return false;
      } else
        this.setState({ candidateError: null });
    }

    if (!this.state.filename) {
      this.setState({ errorMessage: 'Attachment is required' });
      return false;
    } else
      this.setState({ errorMessage: null });
    return true;
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      const formData = new FormData();
      formData.append('file', this.state.file);

      // formData doesn't handle null well
      const terms = this.state.terms || '';
      const notes = this.state.notes || '';
      const category = this.state.attachmentCategory || 'None';
      const email = this.state.employer.email_to?.trim() || '';

      formData.append('terms', terms);
      formData.append('notes', notes);
      formData.append('category', category);
      formData.append('email', email);

      const { invoice, salary, fee, candidateId, execution, expiration } = this.state;
      if (invoice && category === 'Invoice') {
        formData.append('invoice', invoice);
        formData.append('salary', salary);
        formData.append('fee', fee);
        formData.append('candidateId', candidateId);
      }
      if (execution) {
        formData.append('execution', execution);
      }
      if (expiration) {
        formData.append('expiration', expiration);
      }

      const employerId = this.props.params.id;
      const url = `${getBaseUrl()}/v1/employer/${employerId}/attach`;
      fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      })
        .then(result => checkStatus(result))
        .then(response => {
          this.setState({ forward: `/employer/${employerId}`, successMessage: 'Employer Attachment added', errorMessage: '' });
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  render() {
    if (this.state.forward) {
      return <Navigate to={this.state.forward} />;
    }

    const backUrl = `/employer/${this.props.params.id}`;
    return <>
      <Container sx={{
        maxWidth: { xs: '100%', sm: '100%', md: 800, lg: 800, xl: 800 },
        padding: { xs: '2rem', sm: '2rem', md: '2rem 0 0', lg: '2rem 0 0', xl: '2rem 0 0' },
        margin: '0 auto 1rem',
        textAlign: 'left'
      }}>
        <h1>Add Employer Attachment</h1>

        <Box
          component="form"
          sx={{ '& > :not(style)': { m: '0.5rem 0' } }}
          noValidate
          align="left"
          autoComplete="off"
          onSubmit={this.handleSubmit}
        >
          <TextField name="terms" label="Terms" variant="outlined" multiline minRows="3" maxRows="20" fullWidth onChange={this.handleInputChange} />

          <TextField name="notes" label="Notes" variant="outlined" multiline minRows="3" maxRows="20" fullWidth onChange={this.handleInputChange} />

          <TextField name="execution" label="Execution Date" type="date" variant="outlined" InputLabelProps={{shrink: true}} fullWidth onChange={this.handleInputChange} />

          <TextField name="expiration" label="Expiration Date" type="date" variant="outlined" InputLabelProps={{shrink: true}} fullWidth onChange={this.handleInputChange} />

          <h2>Attachment</h2>
          <FormControl variant="standard" sx={{ minWidth: '12rem' }}>
            <InputLabel id="select-attachment-category-label" className="select-label" sx={{ ml: '1rem' }}>Attachment Category</InputLabel>
            <Select
              name="attachmentCategory"
              labelId="select-attachment-category-label"
              variant="outlined" onChange={this.handleCategoryChange}
              defaultValue="None"
              sx={{ mb: '0.25rem' }}
            >
              <MenuItem value="Unknown">Unknown</MenuItem>
              <MenuItem value="None">None</MenuItem>
              <MenuItem value="Fee Agreement">Fee Agreement</MenuItem>
              <MenuItem value="Job Description">Job Description</MenuItem>
              <MenuItem value="Attachment">Attachment</MenuItem>
              <MenuItem value="Invoice">Invoice</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>

          { this.state.showInvoice &&
            <>

            <TextField name="invoice" label="Invoice Number" type="number" variant="outlined" defaultValue={this.state.invoice} InputLabelProps={{shrink: true}} fullWidth onChange={this.handleInputChange} error={this.state.invoiceError} helperText={this.state.invoiceError} />

            <TextField name="salary" label="Salary" variant="outlined" defaultValue={this.state.salary} InputLabelProps={{shrink: true}} fullWidth onChange={this.handleInputChange} error={this.state.salaryError} helperText={this.state.salaryError} />

            <TextField name="fee" label="Fee" variant="outlined" defaultValue={this.state.fee} InputLabelProps={{shrink: true}} fullWidth onChange={this.handleInputChange} error={this.state.feeError} helperText={this.state.feeError} />


            { this.state.candidates &&
              <FormControl variant="standard" sx={{ minWidth: '12rem' }} >
                <InputLabel id="select-candidate-label" className="select-label" sx={{ ml: '1rem' }}>Invoice Candidate</InputLabel>
                <Select
                  name="candidateId"
                  labelId="select-candidate-label"
                  variant="outlined" onChange={this.handleCandidateChange}
                  value={this.state.candidateId}
                  sx={{ mb: '0.25rem' }}
                  error={this.state.candidateError}
                >
                  <MenuItem key="Cand-None" value={''}>None</MenuItem>
                  {this.state.candidates.map(({ id, last_name, first_name }, index) => <MenuItem key={id} value={id} >{last_name}, {first_name}</MenuItem>)}
                </Select>
                { this.state.candidateError && 
                <FormHelperText>{this.state.candidateError}</FormHelperText>
                }
              </FormControl>
            }

            </>
          }

          <AddAttachment onChange={this.onFilesAdded} target={this.state.attachmentCategory || 'Attachment'} sx={{ width: '100%' }} />

          { this.state.filename && 
            <p>{this.state.filename}</p>
          }

          <Button type="submit" variant="contained" sx={{ display: 'block' }}>Submit</Button>
          <Typography sx={{ mt: '0 !important' }}>{ this.state.successMessage }</Typography>
          <Typography sx={{ color: red[900], mt: '0 !important' }}>{ this.state.errorMessage }</Typography>

          <BackButton url={backUrl} name="Employer" />
        </Box>

      </Container>

    </>;

  }
}

export default withParams(AddEmplAttachmentPage);

